'use strict';

define('counter-module-number',['jquery', 'snap.svg'], function ($) {

  // Use the snap.svg plugin to animate number
  var $counterItems = $('.counter-module-number');

  var
    local_opts = {
      animation_duration: 1000
    };

  var initialize = function() {
    $counterItems.each(function() {
      attachEvents($(this));
    });
  };

  var attachEvents = function($this) {
    // Init animation when module waypoint is reached
    $this.waypoint(function() {
      animateNumber($this);
    }, {
      offset: '85%',
      triggerOnce: true
    });
  };

  var animateNumber = function($this){
    var input = $this.find('.counter-module-number__input').val(),
        number = $this.find('.counter-module-number__number');
      
    Snap.animate(0, input, function (val) {
      number.html(Math.round(val));
    }, local_opts.animation_duration, mina.easeinout);
  };

  return {
    init: initialize
  };
});
